

export const setWhitelistDomainBodyFromState = (userEmail, requestForWhiteListDomain) => {
  let url = ''
  if (userEmail) {
    url = `${encodeURIComponent('e')}=${encodeURIComponent(userEmail)}&`
  }
  return `${url}${encodeURIComponent('domain')}=${encodeURIComponent(requestForWhiteListDomain)}`
}


export const setIsHackathonDomainBodyFromState = (requestFlagIsHackathon) => {
  // let url = ''
  // if (userEmail) {
  //   url = `${encodeURIComponent('e')}=${encodeURIComponent(userEmail)}&`
  // }
  return `${encodeURIComponent('isHackathon')}=${encodeURIComponent(requestFlagIsHackathon)}`
}
